<div class="auth-loading"><p>Connecting Grubhub...</p></div>